import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ReactFlexyTable from "react-flexy-table";
import Pagination from "@material-ui/lab/Pagination";
import { useVettingFiles } from "../../hooks/useVettingFiles";
import "../file/ReactFlexyTable.css";
import ReportDrawer from "./VettingViewReportDrawer";
import isEmpty from 'lodash/isEmpty';
import { ToastsStore } from "react-toasts";
import { callApi } from "../../utils/api";
import moment from "moment";
import Select from 'react-select';
import { ADMIN_ROLE } from "../../utils/role";
import { hasPageAccess } from "../../utils/pagePermissionService";

declare var $: any;
interface VettingFilesProps {
    status: number;
    title: string;
    showEdit?: boolean;
    showPickActions?: boolean;
    isVetting?: boolean;
    showUnhold?: boolean;
    showReport?: boolean;
    showHoldReason?: boolean;
    showExcelDownload?: boolean;
    history: any;
}

const VettingFiles: React.FC<VettingFilesProps> = ({
    status,
    title,
    showEdit = false,
    showPickActions = false,
    isVetting = false,
    showUnhold = false,
    showReport = false,
    showHoldReason = false,
    showExcelDownload = false,
    history,
}) => {

    const {
        files,
        totalDataCount,
        currentPage,
        isFileRefresh,
        isLoading,
        searchTerm,
        unholdreason,
        isHoldLoading,
        isDownloading,
        viewFileId,
        vettingCategory,
        vettingSubCategory,
        vettingErrorCategory,
        mistakeBy,
        reWorkReason,
        required,
        handlePageChange,
        handleSearch,
        pickFile,
        setPickFileId,
        handleRework,
        setReworkFileId,
        getSelectedFile,
        onchange,
        handleUnholdFile,
        downloadExcel,
        setVettingCategory,
        setVettingErrorCategory,
        setVettingSubCategory,
        setMistakeBy,
    } = useVettingFiles(status);

    const [drawerVisible, setDrawerVisible] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [holdDetails, setHoldDetails] = React.useState<any>(null);
    const [outReason, setOutReason] = React.useState<any>(null);
    const [selectVal, setSelectVal] = React.useState<any>(null);
    const [isOutLoading, setIsOutLoading] = React.useState<any>(false);
    const [vettingCategorys, setVettingCategorys] = React.useState<any>([]);
    const [vettingSubCategorys, setVettingSubCategorys] = React.useState<any>([]);
    const [vettingErrorCategorys, setVettingErrorCategorys] = React.useState<any>([]);
    const [mistakeByList, setMistakeByList] = React.useState<any>([]);


    useEffect(() => {
        const loadPermission = async () => {
            const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
            if (!hasHide) {
                ouTime();
            }
        };
        loadPermission();
        getOutTime();
        getVettingCategorys();
        getVettingSubCategorys();
        getVettingErrorCategorys();
        getMistakeBy();
    }, []);

    const getVettingCategorys = () => {
        callApi("GET", "vetting_category_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                setVettingCategorys(files);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const getVettingSubCategorys = () => {
        callApi("GET", "vetting_map_category_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                setVettingSubCategorys(files);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const getVettingErrorCategorys = () => {
        callApi("GET", "vetting_error_category_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                setVettingErrorCategorys(files);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const getMistakeBy = () => {
        callApi("GET", "mistake_by_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                setMistakeByList(files);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const outimeGet = () => {
        setIsOutLoading(true);
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
        let updatedRemainingTime: any = localStorage.getItem('updatedRemainingTime');
        let updatedtime = Math.round(updatedRemainingTime);
        const status: any = localStorage.getItem("dashboard_status");
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (outReason == "") {
            setSelectVal(true);
        }
        else {
            let obj = {
                "file_id": JSON.parse(fileid1),
                "user_id": JSON.parse(userid1),
                "in_reason": JSON.parse(inreason),
                "out_reason": outReason,
                "intime": JSON.parse(intime),
                "outtime": JSON.parse(outtime),
                "insert_date": JSON.parse(outdate),
                "total_seconds": secondsSpent,
                "balance_min": updatedtime,
                "dashboard_status": status,
                "insert_id": insertId
            }

            callApi("POST", "process_eod_insert.php", obj)
                .then(res => res.data)
                .then(response => {
                    setIsOutLoading(false);
                    localStorage.removeItem('updatedRemainingTime');
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    localStorage.removeItem('currentfileId');
                    localStorage.removeItem("query_raised_status");
                    localStorage.removeItem("file_completed_status");
                }).catch((err) => {
                    console.log(err);
                    setIsOutLoading(false);
                    ToastsStore.error("Your Reason Not Stored");
                })
        }
    }

    const onchangeReason = (e: any) => {

        if (e.target.value == "Other") {
            setOutReason(null);
            setSelectVal(false);
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        } else {
            setOutReason(e.target.value);
            setSelectVal(false);
        }
    };

    const getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime))
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
        else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
    }

    const ouTime = () => {
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    }

    const previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    }

    const BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");
        history.push("/file-dashboard/" + JSON.parse(fileid1));
    }

    const onChangeOutReason = (e: any) => {
        setOutReason(e.target.value.replace(/\s+/g, ' ').trim());
        setSelectVal(false);
    };

    // const handleChange = (e, propName?, fieldType?) => {
    //     let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
    //     let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;

    //     const inputValue = fieldValue;
    //     if (/^[ -]/.test(inputValue)) {
    //         console.error("Invalid input. The first letter cannot be a space or hyphen.");
    //         return;
    //     }
    //     if (fieldName == 'mistakeBy') {
    //         setMistakeBy(inputValue)
    //     } else if (fieldName == 'vettingCategory') {
    //         setVettingCategory(inputValue);
    //     } else if (fieldName == "") {
    //         setVettingSubCategory(inputValue); // []
    //     }
    // };

    const handleChange = (e, propName?, fieldType?) => {
        let fieldName, fieldValue;

        if (fieldType === 'singleselect') {
            fieldName = propName;
            fieldValue = e.value;
        } else if (fieldType === 'multiselect') {
            fieldName = propName;
            // e is an array of selected options, map to ids
            fieldValue = e ? e.map((opt: any) => opt.value) : [];
        } else {
            fieldName = e.target.name;
            fieldValue = e.target.value;
        }

        // Validate first character
        const inputValue = fieldValue;
        if (Array.isArray(inputValue)) {
            // skip regex for arrays
        } else if (/^[ -]/.test(inputValue)) {
            console.error("Invalid input. The first letter cannot be a space or hyphen.");
            return;
        }

        // Update state
        switch (fieldName) {
            case 'mistakeBy':
                setMistakeBy(fieldValue);
                break;
            case 'vettingCategory':
                setVettingCategory(fieldValue);
                break;
            case 'vetting_error_category':
                setVettingErrorCategory(fieldValue);
                break;
            case 'vetting_sub_category':
                setVettingSubCategory(fieldValue);
                break;
            default:
                console.warn("Unknown field:", fieldName);
        }
    };

    const handleViewReport = (file: any) => {
        setSelectedFile(file);
        setDrawerVisible(true);
    };

    const closeDrawer = () => {
        setDrawerVisible(false);
        setSelectedFile(null);
    };

    const editFile = (modal: any) => {
        history.push({
            pathname: "/vetting-add/" + modal.id,
            state: { fromLoginFile: true }
        });
    };

    const goTo = (file: any) => {
        if (isVetting) {
            history.push({
                pathname: "/vetting-overview/" + file.id,
            });
            localStorage.setItem("vetting_takenfile_id", JSON.stringify(file.id));
        }
    }

    const viewReason = (val: any) => {
        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                const element: any = files[i];
                if (element.id == val.id) {
                    setHoldDetails(element.all_hold);
                    $("#view-reasson").modal("show");
                }
            }
        }
    };

    const columns = [
        {
            header: "S.No",
            key: "serial_no",
            td: (file: any) => (
                <td
                    onClick={() => goTo(file)}
                >
                    {file.serial_no}
                </td>
            ),
        },
        ...(showUnhold
            ? [
                {
                    header: "Actions",
                    td: (file) => {
                        return <div className="btn-group mb-2 mr-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => getSelectedFile(file)}
                                data-toggle="modal"
                                data-target="#holdModal"
                            >
                                Unhold
                            </button>
                        </div>
                    }
                }
            ]
            : []),
        ...(showEdit
            ? [
                {
                    header: "Actions",
                    td: (file) => {
                        return <div className="btn-group mb-2 mr-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() =>
                                    editFile(file)
                                }
                            >
                                Edit
                            </button>
                        </div>
                    }
                }
            ]
            : []),
        {
            header: "File Id",
            key: "file_no",
            td: (file: any) => (
                <td
                    onClick={() => goTo(file)}
                >
                    {file.file_no}
                </td>
            ),
        },
        {
            header: "Lawhands Branch",
            key: "lh_branch",
            td: (file: any) => (
                <td
                    onClick={() => goTo(file)}
                >
                    {file.lh_branch}
                </td>
            ),
        },
        {
            header: "Bank Name",
            key: "bank_name",
            td: (file: any) => (
                <td
                    onClick={() => goTo(file)}
                >
                    {file.bank_name}
                </td>
            ),
        },
        {
            header: "Borrower Name",
            key: "borrower_name",
            td: (file: any) => (
                <td
                    onClick={() => goTo(file)}
                >
                    {file.borrower_name}
                </td>
            ),
        },
        {
            header: "Property Owner Name",
            key: "property_owner",
            td: (file: any) => (
                <td
                    onClick={() => goTo(file)}
                >
                    {file.property_owner}
                </td>
            ),
        },
        {
            header: "Created By",
            key: "Created_by",
            td: (file: any) => (
                <td
                    onClick={() => goTo(file)}
                >
                    {file.loginBy}
                </td>
            ),
        },

        ...(showReport ? [
            {
                header: "Actions",
                td: (file) => (
                    <div className="btn-group mb-2 mr-2">
                        <button
                            type="button"
                            className="btn btn-primary"
                        >
                            Action
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className="sr-only">Toggle Dropdown</span>
                        </button>
                        <div
                            className="dropdown-menu"
                            x-placement="top-start"
                            style={{
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                                transform: "translate3d(88px, -2px, 0px)",
                            }}
                        >
                            <a className="dropdown-item"
                                onClick={() => handleViewReport(file)}>
                                View Report
                            </a>
                            <a className="dropdown-item"
                                data-toggle="modal"
                                data-target="#reworkModal"
                                onClick={() => setReworkFileId(file)}>
                                Re-Work
                            </a>
                        </div>
                    </div>
                ),
            },
        ]
            : []),

        ...(showHoldReason
            ? [
                {
                    header: "View reason",
                    td: (file) => {
                        return <div className="btn-group mb-2 mr-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() =>
                                    viewReason(file)
                                }
                            >
                                View
                            </button>
                        </div>
                    }
                }
            ]
            : []),

        ...(showPickActions
            ? [
                {
                    header: "Actions",
                    td: (file: any) => (
                        <div className="btn-group mb-2 mr-2">
                            <button type="button" className="btn btn-primary">
                                Action
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                                data-toggle="dropdown"
                            >
                                <span className="sr-only">Toggle Dropdown</span>
                            </button>
                            <div
                                className="dropdown-menu"
                                style={{
                                    position: "absolute",
                                    top: "0px",
                                    left: "0px",
                                    transform: "translate3d(88px, -2px, 0px)",
                                }}
                            >
                                <a
                                    className="dropdown-item"
                                    data-toggle="modal"
                                    data-target="#pickModal"
                                    style={{ border: "none", display: "block", margin: "auto" }}
                                    onClick={() => setPickFileId(file)}
                                >
                                    Pick File
                                </a>
                            </div>
                        </div>
                    ),
                },
            ]
            : []),
    ];

    const noOfPages = Math.ceil(totalDataCount / 20);

    // const filteredSubCategories: any = vettingSubCategorys && vettingSubCategorys.length > 0
    //     ? vettingSubCategorys.filter(
    //         (item: any) => item.category === vettingErrorCategory
    //     )
    //     : [];

    const filteredSubCategories: any =
        vettingSubCategorys && vettingSubCategorys.length > 0
            ? vettingSubCategorys.filter((item: any) =>
                Array.isArray(vettingErrorCategory)
                    ? vettingErrorCategory.includes(item.category) // ✅ multiple categories
                    : item.category === vettingErrorCategory
            )
            : [];


    return (
        <section className="pcoded-main-container">
            <div className="pcoded-wrapper">
                <div className="pcoded-content">
                    <div className="pcoded-inner-content">
                        <div className="main-body">
                            <div className="page-wrapper">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h5 className="file-status-header">{title}</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="search-container d-flex justify-content-end">
                                                    {showExcelDownload &&
                                                        <button
                                                            className="download-table-xls-button excel-download-btn"
                                                            onClick={downloadExcel}
                                                            disabled={isDownloading}
                                                            style={{ marginRight: "10px" }}

                                                        >
                                                            {isDownloading ? "Downloading..." : "Download"}
                                                        </button>
                                                    }
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search files..."
                                                        value={searchTerm}
                                                        onChange={handleSearch}
                                                        style={{ marginTop: "10px", marginBottom: "15px", maxWidth: "300px" }}
                                                    />
                                                </div>

                                                {isFileRefresh ?
                                                    <>
                                                        <ReactFlexyTable
                                                            data={files}
                                                            columns={columns}
                                                            sortable
                                                            className="Flexy-table-unhold salary-queue-report-table"
                                                            pageSize={20}
                                                            showTotalRecords={false}
                                                        />
                                                        {noOfPages > 1 && (
                                                            <div className="pagination-container">
                                                                <div>
                                                                    <span>Total data count: {totalDataCount}</span>
                                                                </div>
                                                                <Pagination
                                                                    count={noOfPages}
                                                                    page={currentPage}
                                                                    onChange={handlePageChange}
                                                                    showFirstButton
                                                                    showLastButton
                                                                />
                                                            </div>
                                                        )}
                                                    </>
                                                    : <>
                                                        <i className="fa fa-spinner fa-spin"></i> Loading...
                                                    </>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {showPickActions && (
                                    <div
                                        className="modal fade"
                                        id="pickModal"
                                        tabIndex={-1}
                                        role="dialog"
                                        aria-labelledby="pickModalLabel"
                                        aria-hidden="true"
                                    >
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5>
                                                        Are you sure you want to pick this file {viewFileId}?
                                                    </h5>
                                                </div>
                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        data-dismiss="modal"
                                                    >
                                                        No
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={pickFile}
                                                        disabled={isLoading}
                                                    >
                                                        {isLoading ? (
                                                            <i className="fa fa-spinner fa-spin"></i>
                                                        ) : (
                                                            "Yes"
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div
                                    className="modal fade"
                                    id="reworkModal"
                                    tabIndex={-1}
                                    role="dialog"
                                    aria-labelledby="reworkModalLabel"
                                    aria-hidden="true"
                                >
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5>
                                                    Are you sure you want to rework this file {viewFileId}?
                                                </h5>
                                            </div>
                                            <div className="modal-body">
                                                <div className="form-group">
                                                    <label>Mistake Made By<span style={{ color: "red" }}>*</span></label>
                                                    {mistakeByList && mistakeByList.length > 0 && mistakeByList.map((opt: any) => {
                                                        opt.label = opt.mistake_by; opt.value = opt.id
                                                    }) &&
                                                        <Select options={mistakeByList} name="mistakeBy" className={required && mistakeBy == '' ? 'form-select is-invalid' : 'form-select'}
                                                            value={mistakeByList.find((o: any) => o.value === mistakeBy)}
                                                            onChange={(e) => handleChange(e, 'mistakeBy', 'singleselect')}
                                                        />
                                                    }
                                                    {mistakeByList && mistakeByList.length == 0 &&
                                                        <Select options={[]} name="mistakeBy" className={required && mistakeBy == '' ? 'form-select is-invalid' : 'form-select'}
                                                            value={null}
                                                            onChange={(e) => handleChange(e, 'mistakeBy', 'singleselect')}
                                                        />
                                                    }
                                                    <div className="invalid-feedback">*Required Field</div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Error Type<span style={{ color: "red" }}>*</span></label>
                                                    {vettingCategorys && vettingCategorys.length > 0 && vettingCategorys.map((opt: any) => {
                                                        opt.label = opt.category; opt.value = opt.id
                                                    }) &&
                                                        <Select options={vettingCategorys} name="vetting_category" className={required && vettingCategory == '' ? 'form-select is-invalid' : 'form-select'}
                                                            value={vettingCategorys.find((o: any) => o.value === vettingCategory)}
                                                            onChange={(e) => handleChange(e, 'vettingCategory', 'singleselect')}
                                                        />
                                                    }
                                                    {vettingCategorys && vettingCategorys.length == 0 &&
                                                        <Select options={[]} name="vetting_category" className={required && vettingCategory == '' ? 'form-select is-invalid' : 'form-select'}
                                                            value={null}
                                                            onChange={(e) => handleChange(e, 'vettingCategory', 'singleselect')}
                                                        />
                                                    }
                                                    <div className="invalid-feedback">*Required Field</div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Type of Error Category<span style={{ color: "red" }}>*</span></label>

                                                    <Select
                                                        isMulti   // ✅ enable multiple select
                                                        closeMenuOnSelect={false}
                                                        options={
                                                            vettingErrorCategorys && vettingErrorCategorys.length > 0
                                                                ? vettingErrorCategorys.map((opt: any) => ({
                                                                    label: opt.category,
                                                                    value: opt.id
                                                                }))
                                                                : []
                                                        }
                                                        name="vetting_error_category"
                                                        className={
                                                            required && (!vettingErrorCategory || vettingErrorCategory.length === 0)
                                                                ? 'form-select is-invalid'
                                                                : 'form-select'
                                                        }

                                                        value={
                                                            Array.isArray(vettingErrorCategory)
                                                                ? vettingErrorCategory
                                                                    .map((id: any) => {
                                                                        const match = vettingErrorCategorys.find((o: any) => o.id == id);
                                                                        return match ? { label: match.category, value: match.id } : null;
                                                                    })
                                                                    .filter(Boolean)
                                                                : []
                                                        }

                                                        onChange={(e) => handleChange(e, 'vetting_error_category', 'multiselect')}
                                                    />

                                                    <div className="invalid-feedback">*Required Field</div>
                                                </div>


                                                <div className="form-group">
                                                    <label>Sub-Category<span style={{ color: "red" }}>*</span></label>

                                                    <Select
                                                        isMulti   // ✅ enable multiselect
                                                        closeMenuOnSelect={false}

                                                        options={
                                                            vettingErrorCategory
                                                                ? filteredSubCategories.length > 0
                                                                    ? filteredSubCategories.map((opt: any) => ({
                                                                        label: `${opt.category_name}-${opt.subCategory_name}`,
                                                                        value: opt.id
                                                                    }))
                                                                    : [{ label: "No Sub-Category Available", value: "" }]
                                                                : [{ label: "Select Category First", value: "" }]
                                                        }

                                                        name="vetting_sub_category"

                                                        className={
                                                            required && (!vettingSubCategory || vettingSubCategory.length === 0)
                                                                ? 'form-select is-invalid'
                                                                : 'form-select'
                                                        }

                                                        value={
                                                            Array.isArray(vettingSubCategory)
                                                                ? vettingSubCategory
                                                                    .map((id: any) => {
                                                                        const match = filteredSubCategories.find((o: any) => o.id == id);
                                                                        return match ? { label: match.subCategory_name, value: match.id } : null;
                                                                    })
                                                                    .filter(Boolean) // remove nulls
                                                                : []
                                                        }

                                                        onChange={(e) =>
                                                            handleChange(e, 'vetting_sub_category', 'multiselect')
                                                        }

                                                        isDisabled={!vettingErrorCategory}
                                                    />

                                                    <div className="invalid-feedback">*Required Field</div>
                                                </div>

                                                <div
                                                    className="form-group"
                                                >
                                                    <label>Reason<span style={{ color: "red" }}>*</span></label>
                                                    <textarea
                                                        className={required && isEmpty(reWorkReason) ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Type Reason"
                                                        name="reWorkReason"
                                                        onChange={e => onchange(e)}
                                                    />
                                                    <div className="invalid-feedback">*Required Field</div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    data-dismiss="modal"
                                                >
                                                    No
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={handleRework}
                                                >
                                                    Yes
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ReportDrawer
                visible={drawerVisible}
                onClose={closeDrawer}
                fileData={selectedFile} match={undefined}
            />

            <div
                className="modal fade"
                id="holdModal"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="holdModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>
                                Are you sure you want to unhold {" "}{viewFileId}?
                            </h5>
                        </div>

                        <div className="modal-body">
                            <p style={{ textAlign: "center", color: "black" }}>
                                Please Type a Reason To Unhold The File
                            </p>
                            <div
                                className="form-group"
                                style={{ width: "98%", margin: "auto" }}
                            >
                                <textarea
                                    className="form-control"
                                    placeholder="Type Your Reason"
                                    name="unholdreason"
                                    onChange={e => onchange(e)}
                                />
                                {isEmpty(unholdreason) ? (
                                    <p
                                        style={{
                                            color: "red",
                                            textAlign: "center",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Please type your reason{" "}
                                    </p>
                                ) : null}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                No
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => handleUnholdFile()}
                            >
                                {isHoldLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : (
                                    "Yes"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal fade bd-example-modal-lg"
                id="view-reasson"
                tabIndex={-1}
                role="dialog"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog"
                    style={{
                        maxWidth: "1400px",
                        maxHeight: "660px",
                        overflow: "hidden",
                    }}
                    role="document"
                >
                    <div
                        className="modal-content"
                        style={{
                            borderRadius: "10px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <div
                            className="modal-header"
                            style={{
                                backgroundColor: "#007bff",
                                color: "white",
                                borderBottom: "none",
                                borderTopLeftRadius: "10px",
                                borderTopRightRadius: "10px",
                            }}
                        >
                            <h5
                                className="modal-title"
                                style={{ textAlign: "center", color: "white" }}
                            >
                                Hold & Unhold Details
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true" style={{ color: "white" }}>
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div
                            className="modal-body"
                            style={{
                                backgroundColor: "#f8f9fa",
                                padding: "20px",
                                borderRadius: "8px",
                                maxHeight: "670px",
                                overflowY: "scroll",
                            }}
                        >
                            <div className="dt-responsive table-responsive">
                                <table className="table table-striped table-bordered table-hover">
                                    <thead
                                        className="thead sticky-table-header"
                                        style={{ background: "#d9d9d9" }}
                                    >
                                        <tr style={{ fontSize: "14px" }}>
                                            <th scope="col" className="text-center th">
                                                S.no
                                            </th>
                                            <th scope="col" className="text-center th">
                                                Hold Data
                                            </th>
                                            <th scope="col" className="text-center th">
                                                Hold By
                                            </th>
                                            <th scope="col" className="text-center th">
                                                Hold Reason
                                            </th>
                                            <th scope="col" className="text-center th">
                                                Unhhold Data
                                            </th>
                                            <th scope="col" className="text-center th">
                                                Unhold By
                                            </th>
                                            <th scope="col" className="text-center th">
                                                Unhold Reason
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="tbody">
                                        {holdDetails &&
                                            holdDetails.map((data: any, index: any) => (
                                                <tr key={index}>
                                                    <td className="text-center td">{index + 1}</td>
                                                    <td className="text-center td">{data.hold_dt}</td>
                                                    <td className="text-center td">{data.hold_by}</td>
                                                    <td
                                                        className="text-center td"
                                                        style={{ width: "25%", padding: "1%" }}
                                                    >
                                                        {data.hold_reason}
                                                    </td>
                                                    <td className="text-center td">{data.unhold_dt}</td>
                                                    <td className="text-center td">{data.unhold_by}</td>
                                                    <td
                                                        className="text-center td"
                                                        style={{ width: "25%", padding: "1%" }}
                                                    >
                                                        {data.unhold_reason}
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div
                            className="modal-footer"
                            style={{
                                border: "none",
                                backgroundColor: "#f8f9fa",
                                borderBottomLeftRadius: "10px",
                                borderBottomRightRadius: "10px",
                            }}
                        >
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* THIS FOR OUT REASON MODAL */}
            <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog ">
                    <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                        <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                            <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
                        </div>
                        <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                            <select
                                className="custom-select"
                                name="outreason"
                                value={outReason}
                                onChange={(e) => onchangeReason(e)}
                                required
                                id="select1"
                                style={{ marginTop: '8px' }}
                            >
                                <option value="select">Select Your Reason</option>
                                <option value="Query Raised">Query Raised</option>
                                <option value=" Re-Query Raised"> Re-Query Raised</option>
                                <option value="Hold ">Hold </option>
                                <option value="Completed">Completed</option>
                                <option value="Other">Others</option>

                            </select>
                            {selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                        </div>
                        <div className="modal-footer" style={{ marginTop: '27px' }}>
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={isOutLoading}
                                onClick={outimeGet}
                                style={{ width: '76px', fontSize: '17px' }}
                            > {isOutLoading ? (
                                <i className="fa fa-spinner fa-spin"></i>
                            ) : "OK"}</button>
                            <button
                                type="button"
                                className="btn btn-outline"
                                onClick={BacktoFile}
                                style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                            > Back To File</button>
                        </div>
                    </div>
                </div>
            </div>
            {/* OTHER REASON MODAL */}
            <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog ">
                    <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                        <h5 style={{ marginTop: '31px', textAlign: 'center' }}>Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")} </h5>
                        <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>

                            {/* <div className="col-md-5"> */}
                            <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                                <textarea
                                    className="form-control"
                                    placeholder="Type Your Reason"
                                    name="outreason" onChange={onChangeOutReason} />
                                {selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                            </div>
                            {/* </div> */}

                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => outimeGet()}
                                style={{ width: '76px', fontSize: '17px' }}

                            >{isOutLoading ? (
                                <i className="fa fa-spinner fa-spin"></i>
                            ) : "OK"}</button>
                            <button
                                type="button"
                                className="btn btn-outline"

                                onClick={() => previousPop()}
                                // onClick={this.disableModalHandler}
                                style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                            > Back</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VettingFiles;